module.exports = __webpack_public_path__ + "static/media/signin.b639a990.svg";